import { useAvailableAdminRoutes } from '@ApplicationWide/routes/admin/admin-routes';
import { useAvailableNonAdminRoutes } from '@ApplicationWide/routes/non-admin/non-admin-routes';

export const useAllAvailableRoutes = () => {
  const availableNonAdminRoutes = useAvailableNonAdminRoutes();
  const availableAdminRoutes = useAvailableAdminRoutes();
  return [...availableNonAdminRoutes, ...availableAdminRoutes];
};
